import React, { useEffect, useState } from "react";
import {
  FaUserTie,
  FaBoxOpen,
  FaShoppingCart,
  FaUsers,
} from "react-icons/fa";
import useAxios from "../api/useAxios";


const DashboardPage = () => {
  const axios = useAxios();

  const [stats, setStats] = useState({
    totalAgents: 0,
    totalCustomers: 0,
    totalProducts: 0,
    totalOrders: 0,
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchDashboardStats = async () => {
      try {
        const response = await axios.get("/dashboard/counts");

        setStats(response.data.data);
      } catch (error) {
        console.error("Failed to fetch dashboard stats", error);
      } finally {
        setLoading(false);
      }
    };

    fetchDashboardStats();
  }, [axios]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <p className="text-lg font-semibold">Loading dashboard...</p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-blue-50 p-6">
      <h1 className="text-2xl font-bold mb-6">Dashboard</h1>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {/* Total Agents */}
        <DashboardCard
          title="Total Sales Agents"
          value={stats.totalAgents}
          icon={<FaUserTie size={24} />}
        />

        {/* Total Products */}
        <DashboardCard
          title="Total Products"
          value={stats.totalProducts}
          icon={<FaBoxOpen size={24} />}
        />

        {/* Total Orders */}
        <DashboardCard
          title="Total Orders"
          value={stats.totalOrders}
          icon={<FaShoppingCart size={24} />}
        />

        {/* Total Customers */}
        <DashboardCard
          title="Total Customers"
          value={stats.totalCustomers}
          icon={<FaUsers size={24} />}
        />
      </div>
    </div>
  );
};

const DashboardCard = ({ title, value, icon }) => {
  return (
    <div className="bg-white rounded-xl shadow p-5 flex items-center justify-between">
      <div>
        <p className="text-sm text-gray-500">{title}</p>
        <h2 className="text-2xl font-bold mt-1">{value}</h2>
      </div>

      <div className="bg-blue-100 text-blue-600 p-3 rounded-full">
        {icon}
      </div>
    </div>
  );
};

export default DashboardPage;
